"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Col_1 = tslib_1.__importDefault(require("react-bootstrap/Col"));
const Container_1 = tslib_1.__importDefault(require("react-bootstrap/Container"));
const Row_1 = tslib_1.__importDefault(require("react-bootstrap/Row"));
function Body({ children }) {
    return (jsx_runtime_1.jsx("main", { children: jsx_runtime_1.jsx(Container_1.default, Object.assign({ fluid: true }, { children: jsx_runtime_1.jsx(Row_1.default, { children: jsx_runtime_1.jsx(Col_1.default, { children: children }, void 0) }, void 0) }), void 0) }, void 0));
}
exports.Body = Body;
//# sourceMappingURL=Body.js.map